import { render, staticRenderFns } from "./ReasonAiMyprForm.vue?vue&type=template&id=21c7ecb8"
import script from "./ReasonAiMyprForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReasonAiMyprForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports